<template>
  <div id="app">
    <b-container class="light">
      <router-view />
    </b-container>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
